import apiUrl from '../constants';
import {externalDisputeActions} from '../services/externalDispute';
import axios from 'axios';


export function actionStatuses(status, bucketCode, token){
    return new Promise((resolve, reject) => {
        try{
            let inputPayload = {
                investigateshipmentstatusmasterid: status,
                investigationbuckettypeid: bucketCode,
            }
            axios({
                method: 'post',
                url: apiUrl.api_url + 'TakeAction',
                data: inputPayload,
                headers: {
                  'Authorization': 'Bearer ' + token
                }
              }).then((result) => {
                var takeactiondata = [];
                let externalDisputeActionsMap = externalDisputeActions();
                result.data.data.forEach((x) => {
                  takeactiondata.push({
                    id: x.investigationactionmasterid,
                    label: externalDisputeActionsMap[x.investigationactionmasterid] ? externalDisputeActionsMap[x.investigationactionmasterid] : x.actionname,
                  });
                });
                return resolve(takeactiondata);
              });
        }catch(Exception){
            return reject(Exception);
        }
    }) 
}


// WEBPACK FOOTER //
// ./src/services/actionStatus.js